"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatServiceTypePlural = exports.formatServiceTypeSingular = void 0;
const ServiceType_1 = require("./ServiceType");
const alternateSuffixes = {
    [ServiceType_1.ServiceType.CAR_WASH]: 'es',
    [ServiceType_1.ServiceType.HAIRCUT]: 's',
    [ServiceType_1.ServiceType.OIL_CHANGE]: 's',
    [ServiceType_1.ServiceType.SKATE_SHARPENING]: 's',
    // TODO: find a better way to remap these
    [ServiceType_1.ServiceType.FINANCIAL]: ' advisory sessions',
    [ServiceType_1.ServiceType.MASSAGE]: 's',
    [ServiceType_1.ServiceType.FITNESS_CLASS]: '',
    [ServiceType_1.ServiceType.COOKING_CLASS]: 'es',
    [ServiceType_1.ServiceType.CHEF_SERVICES]: 'es',
    [ServiceType_1.ServiceType.WELLNESS]: ' services',
    [ServiceType_1.ServiceType.ASL_CLASS]: 'es',
};
const overrides = {
    [ServiceType_1.ServiceType.FITNESS_CLASS]: 'Fitness',
};
const formatServiceTypeSingular = (st) => {
    const ov = overrides[st];
    if (ov) {
        return ov;
    }
    const result = /(^[a-z][a-zA-Z]+)(?:_|-)?([a-z][a-zA-Z]+)?/.exec(st);
    const str = result ? `${result[1][0].toUpperCase()}${result[1].substring(1)}${result[2] ? ` ${result[2][0].toUpperCase()}${result[2].substring(1)}` : ''}` : st;
    return str;
};
exports.formatServiceTypeSingular = formatServiceTypeSingular;
const formatServiceTypePlural = (st) => {
    const altSuf = alternateSuffixes[st];
    const ov = overrides[st];
    if (ov) {
        return `${ov}${altSuf || ''}`;
    }
    const suffix = (altSuf !== undefined ? altSuf : '');
    const formatted = (0, exports.formatServiceTypeSingular)(st);
    return `${formatted}${suffix}`;
};
exports.formatServiceTypePlural = formatServiceTypePlural;
